import { ReactNode } from "react";

import { View } from "./View";

interface IInlineTableProps<T> {
  data: T[];
  title: string;
  subtitle: string;
  viewAllUrl: string;
  total: number;
  totalCurrencySymbol: string;
  renderRow: (item: T) => ReactNode;
}

export function InlineTable<TData>(props: IInlineTableProps<TData>) {
  return <View {...props} />;
}
